module.exports = __webpack_public_path__ + "img/keycloak.0d206dc7.svg";